export default __webpack_public_path__ + "static/media/logo.8d5f1d1b.png";